// extracted by mini-css-extract-plugin
module.exports = {"root":"Table-root-RSSTq","fullWidth":"Table-fullWidth-1bXPW"};